import { Link } from "react-router-dom";
import styled from "styled-components";

export const Sessao = styled.div`
  padding: 0 30px;
  width: 100%;
  margin-bottom: 200px;
  @media screen and (max-width: 414px) {
    padding: 0 24px;
    margin-bottom: 100px;
  }
`;
export const Container = styled.div`
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  > p {
    font-size: 20px;
    color: #071242;
    font-weight: 500;
    text-align: start;
    margin-bottom: 40px;

    @media screen and (max-width: 1366px) {
      font-size: 18px;
    }
    @media screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 300px));
  gap: 30px;
  align-items: center;

  margin-bottom: 50px;
  @media screen and (max-width: 768px) {
    gap: 20px;
  } ;
`;

export const ButtonLink = styled(Link)`
  align-self: center;
`;
